import {
  faCaretSquareLeft,
  faCaretSquareRight
} from '@fortawesome/free-regular-svg-icons';
import Flex from 'components/common/Flex';
import IconButton from 'components/common/IconButton';
import { useState } from 'react';
import { Card, Col, OverlayTrigger, Row, Tooltip } from 'react-bootstrap';
import ReportList from '../ReportList';

const CustomReportLayout = ({ children }) => {
  const [showMenu, setShowMenu] = useState(true);
  const [reportName, setReportName] = useState('');

  return (
    <Row className="gx-3">
      {showMenu && (
        <Col md={3}>
          <ReportList reportName={name => setReportName(name)} />
        </Col>
      )}
      <Col md={showMenu ? 9 : 12}>
        <Card>
          <Flex alignItems="center" className="w-100 px-2 py-3">
            <OverlayTrigger
              overlay={
                <Tooltip>{showMenu ? 'Ocultar menu' : 'Expadir menu'}</Tooltip>
              }
            >
              <IconButton
                icon={showMenu ? faCaretSquareLeft : faCaretSquareRight}
                variant="link"
                sizeIcon="sm"
                size="sm"
                className="ms-2 me-1 text-body"
                onClick={() => setShowMenu(!showMenu)}
              />
            </OverlayTrigger>
            <h4 className="p-0 m-0">{reportName}</h4>
          </Flex>
          <Card.Body>
            <div>{children}</div>
          </Card.Body>
        </Card>
      </Col>
    </Row>
  );
};

export default CustomReportLayout;
